import { Tile, TileBody } from '../../../components/shared';
import { CachTinhHanMuc } from '../../tenant/components/ChiTietHanMucToken';
import { ThuTuDungToken } from '../../tenant/components/ThuTuDungToken';
import type { AiTokenQuota } from '../../tenant/types';
import { YeuCauTokenToChuc } from './YeuCauTokenToChuc';

/** Thẻ Nạp token: yêu cầu nạp, thứ tự trừ các túi token và cách tính hạn mức. Số của gói đọc ở phần tóm tắt phía trên. */
export function TabNapToken({ tenantId, quota }: { tenantId: string; quota: AiTokenQuota | undefined }) {
  return (
    <div className="space-y-4">
      <Tile>
        <TileBody>
          <YeuCauTokenToChuc tenantId={tenantId} />
        </TileBody>
      </Tile>
      {quota && (
        <Tile>
          <TileBody className="space-y-3">
            <ThuTuDungToken q={quota} tenantId={tenantId} duocSua />
            <CachTinhHanMuc q={quota} doiTuong="to-chuc" />
          </TileBody>
        </Tile>
      )}
    </div>
  );
}
